// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__z-Rmh","total":"Cart_total__gzNuQ","actions":"Cart_actions__+ftl3","button--alt":"Cart_button--alt__6bgdo","button":"Cart_button__-x4qI"};